import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Radar } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// Handles the Google OAuth return: reads session_id from the URL fragment, exchanges it, then redirects.
export default function AuthCallback() {
  const { completeGoogleSession } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    (async () => {
      if (!sid) { navigate("/login", { replace: true }); return; }
      try {
        await completeGoogleSession(sid);
        window.history.replaceState(null, "", window.location.pathname);
        toast.success("Signed in with Google");
        navigate("/feed", { replace: true });
      } catch {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [completeGoogleSession, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#080B11] text-slate-300">
      <Radar size={30} className="text-[#00E5A3] animate-spin mb-4" />
      <p className="font-mono text-sm">Signing you in…</p>
    </div>
  );
}
